<template>
    <div class="container">
        <div class="word-container">
            <h3 class="hd-36 black bold">{{ $t('web.travel-insurance.slogan') }}</h3>
        </div>
        <div class="insurance-container">
            <div class="image-container">
                <img v-if="displayStep == 1" src='/images/insurance-step1.png' />
                <img v-if="displayStep == 2" src='/images/insurance-step2.png' />
                <img v-if="displayStep == 3" src='/images/insurance-step3.png' />
            </div>
            <div class="step-container">
                <a @click="step1Click" v-bind:class="{ active: displayStep == 1 }" class="step">
                    <div class="title">
                        <img src='/images/fx-step1-bar.svg'>
                        <a class="hd-24 black bold">{{ $t('web.travel-insurance.step1') }}</a>
                    </div>
                    <div class="step-detail shuttle-gray body">{{ $t('web.travel-insurance.step1-detail') }}</div>
                </a>
                <a @click="step2Click" v-bind:class="{ active: displayStep == 2 }" class="step">
                    <div class="title">
                        <img src='/images/fx-step2-bar.svg'>
                        <a class="hd-24 black bold">{{ $t('web.travel-insurance.step2') }}</a>
                    </div>
                    <div class="step-detail shuttle-gray body">{{ $t('web.travel-insurance.step2-detail') }}</div>
                </a>
                <a @click="step3Click" v-bind:class="{ active: displayStep == 3 }" class="step">
                    <div class="title">
                        <img src='/images/fx-step3-bar.svg'>
                        <a class="hd-24 black bold">{{ $t('web.travel-insurance.step3') }}</a>
                    </div>
                    <div class="step-detail shuttle-gray body">{{ $t('web.travel-insurance.step3-detail') }}</div>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                displayStep: 1
            }
        },

        methods: {
            step1Click(){
                this.displayStep = 1;
            },

            step2Click(){
                this.displayStep = 2;
            },

            step3Click(){
                this.displayStep = 3;
            }
        },

        mounted() {

        }
    }
</script>
<style lang="scss" scoped>
    @import "../../sass/_mixin.scss";

    .container{
        .word-container{
            margin-top:8%;
            text-align: center;
        }
        .insurance-container{
            display: flex;
            margin-top: 32px;
            @include responsive(){
                display: block;
            }
            .image-container{
                padding-top: 50%;
                position: relative;
                width: 41%;
                height:auto;
                @include responsive(){
                    margin-left: auto;
                    margin-right: auto;
                    width: 60%;
                    padding-top: unset;
                }

                img{
                    position: absolute;
                    /*width: 100%;*/
                    height: 100%;
                    top: 0;
                    right: 0;
                    object-fit: cover;
                    object-position: center;
                    @include responsive(){
                        width: unset;
                        height: unset;
                        position: unset;
                    }

                }
            }
            .step-container{
                margin-top: 5%;
                margin-bottom: 5%;
                margin-left: 14%;
                width: 41%;
                @include responsive(){
                    margin: unset;
                    margin-top: 12px;
                    display: flex;
                    flex-wrap: wrap;
                    width: 100%;
                }
                .active{
                    background: #EEEEEE;
                    border-radius: 10px;
                    padding-left:2px;
                }
                .step{
                    display: inline-block;
                    padding: 4% 8%;
                    margin-bottom: 8%;
                    width: 100%;
                    &:hover{
                        background: #f7f7f7;
                        border-radius:10px;
                    }
                    @include responsive(){
                        width: 50%;
                    }
                    .title{
                        display: flex;
                        img{
                            margin-right: 4%;
                        }
                    }
                }

            }
        }
    }
</style>
